const questionsSolution = [
  {
    question : 'What is the favorite color of Santa?',
    solution : 'red',
  },
  {
    question : 'what was the original color of Santa?',
    solution : 'green',
  },
  {
    question : 'in what does Santa travel?',
    solution : 'sled',
  },
  {
    question : 'By what is this sled tracted?',
    solution : 'reindeer',
  },
  {
    question : 'Which onomatopoeia is Santa referred to?',
    solution : 'ho ho ho',
  },
  {
    question : 'Have you behave well this year?',
    solution : 'yes',
  },
  {
    question : 'Do you like Santa?????????',
    solution : 'yes',
  },
  {
    question : 'What is the solution?',
    solution : 'laurence',
  }
];

export default questionsSolution;